require('./angular-locale_ru-ru');
module.exports = 'ngLocale';



//////////////////
// WEBPACK FOOTER
// ./~/angular-i18n/ru-ru.js
// module id = 13
// module chunks = 0